module.exports = " <div class=or-cookie__bg> <div class=or-cookie__settings v-if=tstringsReady> <div class=or-cookie__close v-on:click=toggleSettings>{{tstrings.KOKUAPP.CLOSE}}</div> <h1>{{tstrings.KOKUAPP.CENTER_FOR_PRIVACY}}</h1> <div class=or-cookie__items> <cookieitem v-for=\"(index, item) in data\" :data.sync=item :index=index :tstrings.sync=tstrings></cookieitem> </div> <button class=or-cookie__save v-on:click=saveSettings>{{tstrings.KOKUAPP.SAVE_SETTINGS}}</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/kokuapp/cookie-settings.vue
// module id = 232
// module chunks = 13 14